// corresponds to the
export enum EventTypes {
  AgentLeg = 'AgentLeg',
  AgentError = 'AgentError',
  CallContactEvent = 'CallContactEvent',
  ChatContactEvent = 'ChatContactEvent',
  ChatText = 'ChatText',
  AgentSessionStartEvent = 'AgentSessionStart',
}
